import { render, staticRenderFns } from "./social-profile.html?vue&type=template&id=a4e605ee&scoped=true&"
import script from "./social-profile.js?vue&type=script&lang=js&"
export * from "./social-profile.js?vue&type=script&lang=js&"
import style0 from "./social-profile.scss?vue&type=style&index=0&id=a4e605ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e605ee",
  null
  
)

export default component.exports